import React from "react";
import Badge from "../../../library/Badge";
import { getCreditIcon, getCreditTone, MODULE_GROUPS } from "./studyPaths.utils";
import { StyledBadgeRow } from "./studyPaths.styles";

/**
 * Overall credit badge + one chip per non-empty module group — shared by the Study Phases list
 * card (`PhaseCard.js`) and the Re-arrange row (`PhaseRearrangeRow.js`), which each lay it out
 * differently around it.
 * @param {object} props.phase A phase row from `useStudyPathPhaseList` (with `*_supplied_credits`).
 */
function PhaseCreditBadges({ phase }) {
    const overallRequired = MODULE_GROUPS.reduce((total, group) => total + Number(phase[group.creditsField] || 0), 0);
    const overallSupplied = MODULE_GROUPS.reduce((total, group) => total + Number(phase[group.suppliedField] || 0), 0);
    const overallTone = getCreditTone(overallRequired, overallSupplied);

    return (
        <StyledBadgeRow>
            {overallTone && (
                <Badge tone={overallTone} icon={getCreditIcon(overallTone)} iconClass="fas">
                    Credits: {overallRequired}/{overallSupplied}
                </Badge>
            )}

            {MODULE_GROUPS.filter((group) => Number(phase[group.suppliedField] || 0) > 0).map((group) => (
                <Badge key={group.key} tone="grey">
                    {group.label.replace(" Modules", "")}: {phase[group.suppliedField]}
                </Badge>
            ))}
        </StyledBadgeRow>
    );
}

PhaseCreditBadges.displayName = "PhaseCreditBadges";

export default PhaseCreditBadges;
